import React, { useEffect, useState } from 'react';
import { winnreAuth } from '../../../../../utils/axios';
import { getConfig } from '../../../../../utils/config';
import SideModal from '../../../../../Components/Organisms/SideModal';
import GrClose from '@meronex/icons/gr/GrClose';

const question = [
    {
        id: 200,
        question:
            "Can't find what you're looking for? Let us know what you need, and we'll source it for you!",
        type: 'FREE'
    }
];

function MiniSurvey({ showSurvey, handleCloseSurvey }) {
    const config = getConfig();
    const [comment, setComment] = useState('');
    const [loading, setLoading] = useState(false);
    const [formIsValid, setFormIsValid] = useState(false);

    const commentsChangedHandler = (event) => {
        setComment(event.target.value);
    };

    useEffect(() => {
        if (comment != '') {
            setFormIsValid(true);
        }
    }, [comment]);

    const handleSubmit = () => {
        let answer = '';
        if (question[0].type === 'FREE') {
            if (!comment.trim()) {
                return;
            }
            answer = comment;
        }
        winnreAuth({
            method: 'POST',
            url: `winnre/user/mini-survey-answer/submit`,
            data: {
                answer: answer,
                questionId: question[0].id,
                answerSource: 'WEB',
                userSyncClientId: config.id
            }
        })
            .then((res) => {
                // if (res.status === 'FAILED') {
                //     console.log('survey response', res);
                //     setLoading(true);
                //     return;
                // }

                window?.webengage?.track('SurveyAnswered', {
                    questionsId: question[0].id,
                    questionText: question,
                    answerText: answer
                });
                // setShowSurvey(false);
                handleCloseSurvey();
                
            })
            .catch((error) => {
                console.error('Submission error:', error);
            });
    };

    return (
        <>
            <SideModal
                visible={showSurvey}
                survey={true}
                className={'w-full  lg:pl-[15%] lg:pr-[15%]'}
                // onClick={() => {
                //     setShowSurvey(false);
                // }}
                onClick={handleCloseSurvey}
            >
                <div className="relative p-2 lg:p-4 flex flex-col ">
                    <div className="flex flex-row gap-2">
                        <img
                            className="w-[50px] h-[50px]"
                            src="https://cdn.loyalie.in/1722926441360_question_gif"
                        />
                        <h3 className="font-medium text-base md:text-lg  pr-10  p-2 ">
                            {question[0]?.question}
                        </h3>
                    </div>
                    <GrClose
                        // onClick={() => setShowSurvey(false)}
                        onClick={handleCloseSurvey}
                        className={`self-center h-4 w-4 cursor-pointer absolute right-5 top-5`}
                    />

                    {/* Text Area  */}
                    {question[0].type === 'FREE' && (
                        <div className="flex items-center  h-16 lg:h-18 xl:h-20  rounded-lg border border-[#dddddd] p-2 ml-2 lg:ml-[4.5rem] md:ml-[4.5rem]">
                            <textarea
                                type="text"
                                placeholder="Paste the link here"
                                className=" text-black outline-none  w-full  text-grey-900 placeholder:mt-4"
                                onChange={commentsChangedHandler}
                                value={comment}
                            />
                        </div>
                    )}

                    <div className="w-full flex flex-row gap-2 mt-4 justify-start md:justify-end lg:justify-end">
                        <button
                            className="sub-btn px-6 md:px-6 text-white disabled:opacity-70 disabled:bg-gray-400 disabled:cursor-not-allowed"
                            onClick={handleSubmit}
                            disabled={!formIsValid}
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </SideModal>
        </>
    );
}

export default MiniSurvey;
